export const tableCols = [
    { label: "Account", prop: "Account", type: "Account", width: "", isFixed: false },
    { label: "Name", prop: "Name", type: "Name", width: "", isFixed: false },
    { label: "Create time", prop: "createTime", type: "createTime", width: 200, isFixed: false },
    { label: "State", prop: "state", type: "Switch2", width: "", isFixed: false },
    {
        label: "Operation",
        type: "Button",
        width: 330,
        isFixed: "right",
        btnList: [
            {
                type: "",
                label: "Add a related brand",
                handle: row => "addBrand"
            },
            {
                type: "",
                label: "Add Role",
                handle: row => "addRole"
            },
            {
                type: "",
                label: "Delete",
                handle: row => "delete"
            }
        ]
    }
]